const QUEUE_KEY = 'ark-job-queue'
const APPLIED_KEY = 'ark-applied'

// ── Job Queue ────────────────────────────────────────────────────────────────
export const loadQueue = () => {
  try {
    const s = localStorage.getItem(QUEUE_KEY)
    if (s) return JSON.parse(s)
  } catch {}
  return []
}

export const addToQueue = (jobs) => {
  const queue = loadQueue()
  const existing = new Set(queue.map(j => j._key))
  const toAdd = jobs
    .filter(j => !existing.has(j._key))
    .map(j => ({ ...j, _addedAt: new Date().toISOString() }))
  const next = [...queue, ...toAdd]
  localStorage.setItem(QUEUE_KEY, JSON.stringify(next))
  return next
}

export const removeFromQueue = (key) => {
  const next = loadQueue().filter(j => j._key !== key)
  localStorage.setItem(QUEUE_KEY, JSON.stringify(next))
  return next
}

export const clearQueue = () => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify([]))
}

// ── Applied tracker ──────────────────────────────────────────────────────────
export const loadApplied = () => {
  try {
    const s = localStorage.getItem(APPLIED_KEY)
    if (s) return JSON.parse(s)
  } catch {}
  return []
}

export const saveApplied = (entry) => {
  const applied = loadApplied()
  applied.unshift({ ...entry, appliedAt: new Date().toISOString() })
  localStorage.setItem(APPLIED_KEY, JSON.stringify(applied))
  return applied
}

export const removeApplied = (id) => {
  const next = loadApplied().filter(a => a.id !== id)
  localStorage.setItem(APPLIED_KEY, JSON.stringify(next))
  return next
}
